module.exports = __webpack_public_path__ + "media/images/landing_page/dashboard-f364cf136530c9efab51b709c904d9b0.webp";